import React from "react";

const CtaStyleTwo = () => {
  return (
    <section className="cta-style-two no-zigzag">
      <div className="container cta-container">
        
        {/* Content Block */}
        <div className="content-block">
          <p>Book your ride anytime with Om Sai Cab Service</p>

          <h3>Call our travel experts for safe & comfortable rides.</h3>
        </div>

        {/* Button Block */}
        <div className="button-block">
          <a href="/booking" className="cta-btn">
            Book Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaStyleTwo;